@if (showComponent)
{
  <dds-button size="lg"
  theme="dark"
  [icon]="isPopupShown ? 'dds-icon_close' : 'dds-icon_question_mark__s__stroke'"
  class="info-btn"
  [ngClass]="{
    'info-btn_active': isPopupShown
  }"
  [isInverse]="true"
  [ddsSticker]="infoPopup"
  stickerPosition="top-right"
  stickerCustomClass="info-popup"
  [stickerIndent]="8"
  [stickerWidth]="376"
  [stickerIsDynamic]="true"
  (onShown)="onShownPopup()"
  (onHidden)="onHiddenPopup()"></dds-button>

<ng-template #infoPopup>
<strong class="info-popup__title">{{infoData.title}}</strong>
<div [innerHTML]="safeInfoContentHtml"></div>
</ng-template>
}


